import React from "react";
import styles from "./aea-loader.module.scss";

const waitEnd = (props: any) => {
  if (props.progress === props.pendingLoad) {
    return "...";
  }
  return "";
};

const selectLoader = (props: any) => {
  if (props.progress) {
    if (props.pendingLoad > 1 && props.pendingLoad >= props.progress) {
      return (
        <div>
          <div id="myProgress" className={styles.progressBar}>
            <div
              id="myBar"
              className={styles.bar}
              style={{
                width: (props.progress / props.pendingLoad) * 100 + "%",
              }}
            ></div>
          </div>
          <label className={styles.progressCounter}>
            {props.progress + " de " + props.pendingLoad}
          </label>
        </div>
      );
    } else {
      return (
        <div>
          <div id="myProgress" className={styles.progressBar}>
            <div
              id="myBar"
              className={styles.bar}
              style={{ width: props.progress + "%" }}
            ></div>
          </div>
          <label id="labelProgress" className={styles.progressCounter}>
            {props.progress + "%"}
          </label>
        </div>
      );
    }
  }
  return <div></div>;
};

const AEALoader = (props: any) => {
  return (
    <div style={props.style} className={styles.loadContainer}>
      <div style={props.style} className={styles.loadingContainer}>
        <div className={styles.loadingBox2}></div>
        <div className={styles.loadingBox3}></div>
        <div className={styles.loadingBox4}></div>
      </div>
      {selectLoader(props)}
    </div>
  );
};

export default AEALoader;
